import {IntentListItemViewModel} from '@/features/bots/models/intents/intentListItemViewModel';
import {SaveIntentViewModel} from '@/features/bots/models/intents/saveIntentViewModel';
import {IntentViewModel} from '@/features/bots/models/intents/intentViewModel';
import {api} from '@/shared/services/baseApiClient';
import urljoin from 'url-join';
import {config} from '@/config/config';
import { AddUtteranceToIntentViewModel } from '../models/intents/addUtteranceToIntentViewModel';
import { UtteranceViewModel } from '../models/intents/utteranceViewModel';
import {PagedPredictionsViewModel} from '@/features/bots/models/intents/pagedPredictionsViewModel';


class NlpService {
	private version = 'v1';

	public async getIntents(workspaceId: string): Promise<IntentListItemViewModel[]> {
		return await api.send('GET', urljoin(config().nlpHost, this.version, 'models', workspaceId, 'intents'));
	}

	public async addIntent(workspaceId: string, request: SaveIntentViewModel): Promise<IntentViewModel> {
		return api.send('POST', urljoin(config().nlpHost, this.version, 'models', workspaceId, 'intents'), request);
	}

	public async updateIntent(workspaceId: string, request: SaveIntentViewModel, id: string): Promise<IntentViewModel> {
		return api.send('PUT', urljoin(config().nlpHost, this.version, 'models', workspaceId, 'intents', id), request);
	}

	public async deleteIntent(workspaceId: string, intentId: string): Promise<void> {
		return await api.send('DELETE', urljoin(config().nlpHost, this.version, 'models', workspaceId, 'intents', intentId));
	}

	public async getIntent(workspaceId: string, intentId: string): Promise<IntentViewModel> {
		return api.send('GET', urljoin(config().nlpHost, this.version, 'models', workspaceId, 'intents', intentId));
	}

	public async addUtteranceToIntent(workspaceId: string, intentId: string, utterance: string): Promise<UtteranceViewModel> {
		const request: AddUtteranceToIntentViewModel = {
			utterance
		};
		return api.send('POST', urljoin(config().nlpHost, this.version, 'models', workspaceId, 'intents', intentId, 'utterances'), request);
	}

	public async getPredictions(workspaceId: string, limit: number, offset: number): Promise<PagedPredictionsViewModel> {
		return api.send('GET', urljoin(
			config().nlpHost,
			this.version,
			'models',
			workspaceId,
			`predictions?limit=${limit}&offset=${offset}`));
	}

	public async deletePrediction(workspaceId: string, predictionId: string): Promise<void> {
		return await api.send('DELETE', urljoin(config().nlpHost, this.version, 'models', workspaceId, 'predictions', predictionId));
	}
}

export const nlpApi = new NlpService();
